// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  CanonicalAddress,
  CompleteInvitedBrandOnboardingResult,
} from "./types";

export const params = {
  publicCode: __t.option(__t.string()),
  firstName: __t.string(),
  lastName: __t.string(),
  phone: __t.string(),
  dob: __t.string(),
  citizenship: __t.string(),
  residency: __t.string(),
  get address() {
    return CanonicalAddress;
  },
};
export const returnType = CompleteInvitedBrandOnboardingResult